import { Box, Typography } from "@mui/material";
import { diffWords } from "../helpers";

const DiffInline = ({
  oldText,
  newText,
  removedColor = "text.secondary", // deletion text color
}) => {
  const ops = diffWords(oldText, newText);
  return (
    <Typography variant="body2" component="div">
      {ops.map((o, i) => {
        if (o.type === "equal") {
          return (
            <Box key={i} component="span">
              {" " + o.text + " "}
            </Box>
          );
        }
        if (o.type === "removed") {
          return (
            <Box
              key={i}
              component="span"
              sx={{
                color: removedColor,
                textDecoration: "line-through",
                textDecorationThickness: "2px",
              }}
              title={o.text.trim()}
            >
              {o.text}
            </Box>
          );
        }
        // added
        return (
          <Box
            key={i}
            component="span"
            sx={(t) => ({
              fontWeight: "bold",
              color: "orange",
              px: 0.25,
              borderRadius: 0.5,
            })}
            title={o.text.trim()}
          >
            {o.text + " "}
          </Box>
        );
      })}
    </Typography>
  );
};

export default DiffInline;
